import React, { useState } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
const Content = styled(Typography)`
  margin-bottom: 0.3rem;
`;

const TextInput = ({
  label,
  value,
  onChange,
  id,
  type,
  readOnly,
  required,
  error,
  placeholder,
  input,
  meta,
  name,
  showNewPassword,
  handleClickShowNewPassword,
  handleMouseDownNewPassword,
  password,
  disabled,
  prefillValue,
  isAmount,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const inputValue = prefillValue !== undefined ? prefillValue : value;
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {t(label)} {required ? "*" : ""}
        </Typography>
      </Content>
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { width: "100%" },
        }}
        noValidate
        autoComplete="off"
      >
        {label == "Password" || password == "password" ? (
          <TextField
            label={""}
            id={id}
            name={name}
            variant="outlined"
            value={inputValue}
            type={showPassword ? "text" : "password"}
            // type={type}
            onChange={onChange}
            fullWidth
            size="small"
            disabled={disabled}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={
                      handleClickShowPassword || handleClickShowNewPassword
                    }
                    onMouseDown={
                      handleMouseDownPassword || handleMouseDownNewPassword
                    }
                  >
                    {showPassword || showNewPassword ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            placeholder={placeholder}
            error={meta && meta.touched && meta.error && error}
            // helperText={error}
            {...input}
            {...props}
          />
        ) : (
          <TextField
            label={""}
            id={id}
            name={name}
            disabled={disabled}
            variant="outlined"
            value={inputValue}
            type={!!isAmount ? "number" : type}
            onChange={onChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {isAmount && <span style={{ fontWeight: "bold" }}>XAF</span>}
                </InputAdornment>
              ),
            }}
            fullWidth
            size="small"
            placeholder={placeholder}
            error={meta && meta.touched && meta.error && error}
            // helperText={error}
            {...input}
            {...props}
          />
        )}
        {meta && meta.touched && meta.error ? (
          <Typography color="red" fontSize={".8rem"} align={"center"}>
            {t(error)}
          </Typography>
        ) : (
          ""
        )}
      </Box>
    </>
  );
};
TextInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  prefillValue: PropTypes.string,
};
export default TextInput;
